export default function normalizeOptions(options: any = []) {
  if (Array.isArray(options)) {
    return options;
  }

  if (options && typeof options === "object") {
    return Object.entries(options).map(([value, label]) => {
      if (label && typeof label === "object") {
        return {
          value,
          ...(label as any),
        };
      }

      return {
        value,
        label,
      };
    });
  }

  return [];
}
